<template>
  <div v-if="$store.state.profile.campaign_new_user" style="width: auto;" class="bonus-tips-newuse">
    <div class="tips-newuse-pc">
      <img src="../assets/img/free-tip.png" alt="Free Trial"/>
      <img src="../assets/img/free-logo.png" alt="Free Trial"/>
    </div>
    <div class="tips-newuse-mobile">
      <img src="../assets/img/free-logo-pc.png" alt="Free Trial"/>
      <img src="../assets/img/free-tip-pc.png" alt="Free Trial"/>
    </div>
  </div>
  <div class="bonus-tips" v-else>
    <img src="../assets/img/banner-left.png" class="banner-left"/>
    <img src="../assets/img/banner-left-m.png" class="banner-left-m"/>
    <div class="bonus-tips-mid">
      <div class="bonus-tips-left" v-if="holidayNow">
        <p>{{ holiday.banner_main_heading }}</p>
        <p>{{ holiday.banner_sub_heading }}</p>
      </div>
      <div class="bonus-tips-left" v-else>
        <p>{{ $t('messages.home.tip1') }}</p>
        <p>{{ $t('messages.home.tip2') }}</p>
      </div>
      <el-button class="view-btn" type="primary" @click="goDetail">{{ $t('messages.home.tip3') }}</el-button>
    </div>
    <img src="../assets/img/banner-right.png" class="banner-right"/>
    <img src="../assets/img/banner-right-m.png" class="banner-right-m"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  methods: {
    goDetail(){
      this.$router.push('/deposit')
    },
  },
  computed:{
    ...mapState(['holiday']),
    ...mapGetters(['holidayNow']),
  }
}
</script>

<style lang="scss">
.bonus-tips-newuse{
  .tips-newuse-pc{
    background: url(../assets/img/newuse-bg.png) no-repeat;
    // background-size: cover;
    background-size: 100% 100%;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 64px;
    >img{
      &:first-child{
        width: 404px;
        height: 29px;
        margin-right: 14px;
        margin-top: 4px;
      }
      &:last-child{
        width: 65px;
        height: 44px;
      }
    
    }
  }
  .tips-newuse-mobile{
    display: none;
  }
}

.bonus-tips{
  background: #1861F2 linear-gradient(45deg, #7F17FF 0%, #1861F2 52%, #12BCFF 100%);
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  .bonus-tips-mid{
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 104px;
    padding-right: 100px;
    justify-content: space-between;
    .bonus-tips-left{
      display: flex;
      align-items: center;
      >p{
        color: #FFFFFF;
        &:first-child{
          margin-right: 16px;
          font-size: 21px;
        }
        &:last-child{
          font-size: 13px;
          color: #FFFFFF;
        }
      }
    }
    .view-btn{
      background: #fff;
      color: #1861F2;
      border-radius: 4px;
      padding: 10px;
      min-width: 100px;
      border: none;
      cursor: pointer;
      z-index: 2;
    }
  }
  .banner-left,.banner-right{
    height: 64px;
    position: absolute;
  }
  .banner-left,.banner-left-m{
    left: 0;
  }
  .banner-right,.banner-right-m{
    right: 0;
  }
  .banner-left-m,.banner-right-m{
    height: 144px;
    display: none;
    position: absolute;
  }
}

@media screen and (max-width: 1000px){
  .tips-newuse-pc{
    display: none !important;
  }
  .tips-newuse-mobile{
    height: 114px;
    display: flex !important;
    background: url(../assets/img/newuse-bg-mobile.png) no-repeat;
    background-size: cover;
    flex-direction: column;
    align-items: center;
    padding: 6px 0;
    >img{
      &:first-child{
        width: 91px;
        height: 62px;
      }
      &:last-child{
        width: 249px;
        height: 52px;
      }
    }
  }
}

@media screen and (max-width: 780px) {
  .bonus-tips{
    height: 144px;
    .banner-left,.banner-right{
      display: none !important;
    }
    .banner-left-m,.banner-right-m{
      display: inline-block !important;
    }
    .bonus-tips-mid{
      // display: block !important;
      padding: 0 54px;
      flex-direction: column;
      align-items: center;
      height: 110px !important;
    }
    .bonus-tips-left{
      flex-direction: column;
      >p:first-child{
        margin-right: 0 !important;
        font-size: 20px !important;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
      }
      >p:last-child{
        font-size: 14px !important;
        text-align: center;
      }
    }
  }
}
</style>